"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderedOutcomeKeys = getOrderedOutcomeKeys;
const getOutcomeKey_1 = require("../../getOutcomeKey");
const getProbabilities_1 = require("./getProbabilities/getProbabilities");
const sortProbabilities_1 = require("./getProbabilities/sortProbabilities");
function getOrderedOutcomeKeys({ vMarketInfo, orderedOutcomeTypes, outcomes, }) {
    const { orderedBy } = vMarketInfo.outcomesGroup;
    let orderedOutcomeTypeIds = [];
    if (orderedBy === null || orderedBy === void 0 ? void 0 : orderedBy.orderedOutcomeTypeIds) {
        orderedOutcomeTypeIds = [...orderedBy.orderedOutcomeTypeIds];
    }
    if (orderedOutcomeTypeIds.length === 0) {
        orderedOutcomeTypeIds = orderedOutcomeTypes.map(({ id }) => id);
    }
    else {
        orderedOutcomeTypes.forEach((outcomeType) => {
            if (!orderedOutcomeTypeIds.includes(outcomeType.id)) {
                orderedOutcomeTypeIds.push(outcomeType.id);
            }
        });
    }
    const outcomesByType = (0, getProbabilities_1.groupByOutcomeTypeId)(Object.values(outcomes));
    return orderedOutcomeTypeIds.flatMap((outcomeTypeId) => {
        const outcomes = outcomesByType[outcomeTypeId] || [];
        return (0, sortProbabilities_1.sortOutcomes)(outcomes, outcomeTypeId, orderedBy).map((outcome) => (0, getOutcomeKey_1.getOutcomeKey)(outcome));
    });
}
//# sourceMappingURL=getOrderedOutcomeKeys.js.map